import React from 'react';
import { Divider, Typography } from '@mui/material';
import korola from '../../../../../images/Agri-info/crops/korlaaa_করলা.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const KorolaInfo = () => {

    // dynamic title
    useDocumentTitle("করলা");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                করলা
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={korola} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p>করলা বাংলাদেশের অন্যতম প্রধান সবজি। স্বাদে তিক্ত হলেও বাংলাদেশের সকলের নিকট এটি প্রিয় সবজি হিসেবে পরিচিত। ১০০ গ্রাম ভক্ষণ যোগ্য করলায় ১.৫-২.০ ভাগ আমিষ, ২০-২৩ মিলিগ্রাম ক্যালসিয়াম, ১.৮-২.০ মিলিগ্রাম লৌহ এবং ৮৮.৯৬ মিলিগ্রাম খাদ্যপ্রাণ সি আছে। <br />
                                উষ্ণ ও আর্দ্র আবহাওয়ায় করলা ভাল জন্মে। অতিরিক্ত বৃষ্টিপাতে পরাগায়ন বিঘ্নিত হতে পারে। সব রকম মাটিতেই করলার চাষ করা যেতে পারে। জৈব সার সমৃদ্ধ দো-আঁশ বেলে দো-আঁশ মাটিতে ভাল জন্মে। </p>
                            <p className="card-text fw-bold">জাত</p>
                            <p className="card-text fw-bold">বারি করলা-১</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p>
                    • জাতটিতে গাঢ় সবুজ রংয়ের ২৫-৩০ টি ফল ধরে (গাছ প্রতি)<br />
                    • প্রতি ফলের গড় ওজন ১০০ গ্রাম যা লম্বায় ১৭-২০ সেমি এবং ব্যাস ৪-৫ সেমি।<br />
                    • চারা রোপণের ৫৫-৬০ দিনের মধ্যে প্রথম ফল তোলা যায়।<br />
                    • উন্নত পদ্ধতিতে চাষ করলে হেক্টর প্রতি ফলন ২৫-৩০ টন পাওয়া যায়।</p>

                <p className="card-text fw-bold">গজ করলা</p>
                <p className="card-text">
                    • জাতটিতে সবজ রংয়ের ১৫-২০ টি ফল ধরে (গাছ প্রতি)<br />
                    • প্রতি ফলের গড় ওজন ১৫০-২০০ গ্রাম যা লম্বায় ২৫-৩০ সেমি এবং ব্যাস ৬-৭ সেমি।<br />
                    • হেক্টর প্রতি ফলন ২০-২৫ টন(১০০ ১২০ কেজি/শতাংশ) পাওয়া যায়।</p>

                <p className="card-text fw-bold">জীবন কাল </p>
                <p className="card-text">মোট জীবনকাল প্রায় চার থেকে সারে চার মাস। তবে জাত ও আবহাওয়াভেদে কোন কোন সময় কম বেশী হতে পারে। </p>

                <p className="card-text fw-bold">উৎপাদন মৌসুম</p>
                <p className="card-text">ফেব্র্বয়ারি থেকে মে মাসের মধ্যে যে কোন সময় করলার বীজ বোনা যেতে পারে। কেউ কেউ জানুয়ারী মাসেও বীজ বুনে থাকেন কিন্তু এ সময় তাপমাত্রা কম থাকায় গাছ দ্র্বত বাড়তে পারে না, ফলে আগাম ফসল উৎপাদনে তেমন সুবিধা হয় না। </p>

                <p className="card-text fw-bold">বীজের হার</p>
                <p className="card-text">করলা ও উচ্ছের জন্য হেক্টর প্রতি যথাক্রমে ৬-৭.৫ও ৩-৩.৫ কেজি বীজের প্রয়োজন হয়।</p>

                <p className="card-text fw-bold">জমি তৈরী ও বপন পদ্ধতি </p>
                <p className="card-text">উচ্ছে ও করলার বীজ সরাসরি মাদায় (৪০x৪০x৪০ সেমি) বোনা যেতে পারে। এৰেত্রে প্রতি মাদায় কমপক্ষে ২টি বীজ বপন অথবা পলিব্যাগে উৎপাদিত ১৫-২০ দিন বয়সের চারা রোপণ করতে হবে। উচ্ছের ক্ষেত্রে সারিতে ১.০ মিটার এবং করলার জন্য ১.৫ মিটার দূরত্বের মাদা তৈরী করতে হবে। মাদা বীজ বুনতে বা চারা রোপণ করতে হলে অন্তত: ১০ দিন আগে মাদা নির্ধারিত সার প্রয়োগ করে তৈরী করে নিতে হবে। </p>

                <p className="card-text fw-bold">ফসল সংগ্রহ ও ফলন</p>
                <p className="card-text">
                    • চারা গজানোর ৪৫-৪৫ দিন পর উচ্ছের গাছ ফল দিতে থাকে। করলার বেলায় প্রায় ২ মাস লেগে যায়।<br />
                    • স্ত্রীফুলের পরাগায়নের ১৫-২০ দিনের মধ্যে ফল খাওয়ার উপযুক্ত হয়।<br />
                    • ফল আহরণ একবার শুরু হলে তা দুমাস পর্যন্ত অব্যাহত থাকে ফলন। উন্নত পদ্ধতিতে চাষাবাদ করলে উচ্ছে ও করলার হেক্টর প্রতি ফলন যথাক্রমে ৭-১০ টন (৩০-৪০ কেজি/শতাংশ) এবং ২০-২৫ টন (৮০-১০০ কেজি/শতাংশ) পাওয়া যায়।</p>

                <p className="card-text fw-bold">বীজের ফলনঃ </p>
                <p className="card-text">সময়মত সঠিক পরিচর্যা গ্রহণ করলে হেক্টর প্রতি ৩০০-৪০০ কেজি (প্রতি শতাংশে ১.২-১.৬ কেজি) বীজ হতে পারে। </p>

            </div>
        </div >

    );
};

export default KorolaInfo;